"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = void 0;
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const Clonable_1 = require("../Util/Clonable");
/**
 * DTO object from the form input.
 */
const MappedModelBase_1 = require("auto-widget-framework/src/Model/MappedModelBase");
class Customer extends MappedModelBase_1.default {
    constructor() {
        super(...arguments);
        this.subscriptions = [];
    }
    /**
     * Constructs from configuration object.
     *
     * @TODO: Move to transformer.
     *
     * @param customer
     * @return {Customer}
     */
    static fromObject(customer) {
        const instance = new this();
        Object.keys(this.getValueMapping().value).forEach((key) => {
            if (customer[key] !== undefined) {
                instance[key] = customer[key];
            }
        });
        return instance;
    }
    static getValueMapping() {
        /* tslint:disable */
        return super.getValueMapping({
            id: {
                type: "number",
                getter: true,
                required: false,
            },
            firstName: {
                type: "string",
                getter: true,
                required: true,
            },
            lastName: {
                type: "string",
                getter: true,
                required: true,
            },
            phoneNumber: {
                type: "string",
                getter: true,
                regex: /^[+]?.{5,}(?:\(\d+(?:\.\d+)?\)|\d+(?:\.\d+)?)(?:[ -]?(?:\(\d+(?:\.\d+)?\)|\d+(?:\.\d+)?))*(?:[ ]?(?:x|ext)\.?[ ]?\d{1,5})?$/,
                required: true,
            },
            postalCode: {
                type: "string",
                getter: true,
                regex: /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/,
                required: true,
            },
            email: {
                type: "string",
                getter: true,
                regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                required: true,
            },
            subscriptions: {
                type: "array",
                getter: true,
                required: false
            },
            comment: {
                type: "string",
                getter: true,
                required: false,
            },
            subscribed: {
                type: "boolean",
                getter: true,
                required: false,
            },
            privacyPolicy: {
                type: "boolean",
                getter: true,
                required: true,
            }
        });
    }
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getFirstName() {
        return this.firstName;
    }
    setFirstName(value) {
        this.firstName = value;
        return this;
    }
    getLastName() {
        return this.lastName;
    }
    setLastName(value) {
        this.lastName = value;
        return this;
    }
    getEmail() {
        return this.email;
    }
    setEmail(value) {
        this.email = value;
        return this;
    }
    getPostalCode() {
        return this.postalCode;
    }
    setPostalCode(value) {
        this.postalCode = value;
        return this;
    }
    getSubscriptions() {
        return this.subscriptions;
    }
    setSubscriptions(subscriptions) {
        this.subscriptions = subscriptions;
        return this;
    }
    getPhoneNumber() {
        return this.phoneNumber;
    }
    setPhoneNumber(phoneNumber) {
        this.phoneNumber = phoneNumber;
        return this;
    }
    addSubscription(subscription) {
        this.subscriptions.push(subscription);
        return this;
    }
    hasSubscription(subscription) {
        if (Array.isArray(this.subscriptions)) {
            return this.subscriptions.indexOf(subscription) > -1;
        }
        return false;
    }
    getComment() {
        return this.comment;
    }
    setComment(value) {
        this.comment = value;
        return this;
    }
    hasPrivacyPolicy() {
        return this.privacyPolicy;
    }
    setPrivacyPolicy(value) {
        this.privacyPolicy = value;
        return this;
    }
    isSubscribed() {
        return this.subscribed;
    }
    setSubscribed(value) {
        this.subscribed = value;
        return this;
    }
}
exports.Customer = Customer;
exports.default = Customer;
Mixin_1.default(Customer, Clonable_1.default);
